
  import EventDetails from '@/components/EventDetails.vue';
  import jobsSearchUrlHelper from '@/helper/jobsSearchUrlHelper';
  import LazyHydrate from 'vue-lazy-hydration';
  import Events from '@/events/Events';
  import EmployeeSearchBox from '@/components/elements/EmployeeSearchBox.vue';
  import ScreenSize from '@/mixins/ScreenSize';

  export default {
    name: 'SectionEventDetails',
    components: {
      EmployeeSearchBox,
      LazyHydrate,
      EventDetails,
      RelatedEvents: () => import('@/components/RelatedEvents.vue'),
      ShareElement: () => import('@/components/ShareElement'),
    },
    mixins: [ScreenSize],
    props: {
      section: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
    data() {
      return {
        metaData: {},
        seoContentConfig: {},
        event: {},
      };
    },
    mounted() {
      this.$emitWithClientData(Events.EventDetailsViewed, {
        eventId: this.event.id.toString(),
      });
    },
    created() {
      this.event = this.section.event;
    },
    methods: {
      jobsSearchUrl() {
        return jobsSearchUrlHelper(
          this.event.filterParams,
          this.$auth.loggedIn,
          this.$auth.user?.candidateProfile?.addresses[0]
        );
      },
    },
  };
